import { render } from "./PosterDetail.vue?vue&type=template&id=315db6f5&scoped=true"
import script from "./PosterDetail.vue?vue&type=script&lang=js"
export * from "./PosterDetail.vue?vue&type=script&lang=js"

import "./PosterDetail.vue?vue&type=style&index=0&id=315db6f5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315db6f5"]])

export default __exports__